module.exports = __webpack_public_path__ + "img/cover-4.ab01ee67.jpg";